<template>
  <div class="learun-input" >
    <input v-model="value" />
  </div>
</template>
<script>
export default {
  name: "learun-input",
  props: {
    value: {},
    title: String,
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>